import {useQuery} from '@tanstack/react-query'
import {getCategoryList} from '@/services/CategoryService/category'

export const useCategoryList = (dropdownType = '', isEnabled = true) => {
  // For backward compatibility: if no dropdownType is provided, use the old behavior
  const useOldEndpoint = !dropdownType
  
  const query = useQuery({
    queryKey: useOldEndpoint ? ['CATEGORY_LIST'] : ['categoryDropdown', dropdownType],
    queryFn: () => getCategoryList(dropdownType),
    enabled: useOldEndpoint ? isEnabled : (!!dropdownType && isEnabled),
    initialData: useOldEndpoint ? [] : {data: []},
  })

  return {
    categoryListData: useOldEndpoint ? (query?.data || []) : (query?.data?.data || []),
    isLoading: query?.isLoading || false,
  }
}
